export const codeSnippet = {
  code1: `spring:
security:
  oauth2:
    client:
      registration:
        company:
          client-id: app-client-id
          client-secret: app-client-secret
          scope: openid,profile,email
      provider:
        company:
          issuer-uri: https://sso.company.com`,
  code2: `@Configuration
public class SecurityConfig {

  @Bean
  SecurityFilterChain securityFilterChain(HttpSecurity http) throws Exception {

    http
      .csrf(csrf -> csrf.disable())

      .sessionManagement(sess ->
        sess.sessionCreationPolicy(SessionCreationPolicy.STATELESS)
      )

      .authorizeHttpRequests(auth -> auth
        .requestMatchers("/auth/**").permitAll()     // login API public
        .requestMatchers("/admin/**").hasRole("ADMIN")
        .requestMatchers("/user/**").hasAnyRole("USER","ADMIN")      
        .anyRequest().authenticated()
      )

      // 🔐 validate JWT from SSO
      .oauth2ResourceServer(oauth -> oauth.jwt());

    return http.build();
  }
}`,
  code3:`@PreAuthorize("hasRole('ADMIN')")
@GetMapping("/admin/dashboard")
public String getAdminDashboard() {
  return "Secret Admin Data";
}`,
  code4:`@GetMapping("/profile")
public String getUser(Authentication authentication) {
  return "Logged in user: " + authentication.getName();
}`,
  code5:`@GetMapping("/profile")
public String profile(@AuthenticationPrincipal String username) {
  return username;
}`,
  code6: `@GetMapping("/profile")
public Object profile(Authentication auth) {

  String username = auth.getName();

  Collection<? extends GrantedAuthority> roles = auth.getAuthorities();

  return "User: " + username + " Roles: " + roles;
}`,
  code7: `Authentication auth =
SecurityContextHolder.getContext().getAuthentication();

String username = auth.getName();`
}

